<div class="condition-page">
  <div class="condition-details">
    <div class="container">
      <h2> My Lifewell- <a> Privacy Policy </a> </h2>
      <p>
        DC Wellness, Inc. dba Mylifewell (“DC Wellness”, “us”, “we”, or “our”) is concerned about your privacy. We may
        ask you to provide certain information by which you can be identified when using our website, we will only use
        such information in accordance with this privacy statement.
      </p>
      <p>
        Please read this Privacy Policy to learn more about how we collect, use, and protect your personal information.
        This policy will also explain your rights with regard to changing and erasure of your information. We may make
        changes to these policies, which changes will be effective immediately, so please re-visit these pages regularly
        if you want to keep up to date with any changes we’ve made. You acknowledge and agree that it is your
        responsibility to review this Privacy Policy periodically, and be aware of any modifications.
      </p>

      <p> Our Privacy Policy covers all the platforms through which you choose to interact with us, including our
        mobile-enabled and social media sites (together “Our Services”). By giving us your personal information, you
        agree to the transfer, storing, or processing of your data in accordance with this policy. </p>
      <h4>The Information We Collect</h4>
      <p> While using our Services to make a booking or register for an account, you may provide us with certain
        information that can be used to contact or identify you. This information is your personal data. This
        information may include, but is not limited to:</p>
      <ul class="term-list">
        <li>your email address</li>
        <li>name</li>
        <li>phone number</li>
        <li>address;</li>
        <li>and payment method</li>
      </ul>
      <p> Please be aware that this information will still be considered provided to us even if you do not complete a
        booking or registration.</p>
      <p> If you contact us, whether by phone, e-mail, or another method, you’ll be asked to provide certain
        information. This is likely to include your name, address, e-mail address and phone number. We collect this
        information so that we can effectively communicate with you and so we can respond appropriately to your requests
        and inquiries.</p>
      <p> There are also other instances when you’ll provide us with information, for example if you register to manage
        your booking via our website, leave a review, enter one of our competitions or complete a survey.</p>
      <p> We may collect the following information when you use our services or make a booking from our websites and
        mobile apps:</p>

      <ul class="term-list">
        <li>Traveler information, passport details, other ID document details; </li>
        <li>Information about your purchases, including what you bought, when and where you bought it, how you paid for
          it and credit or payment information; </li>
        <li>Information about your browsing behavior on our websites and mobile apps; </li>
        <li>Information about when you click on one of our advertisements, including advertisements on other websites;
        </li>
        <li>Information about the way you access our digital services, including operating system, IP address, online
          identifiers and browser details; </li>
        <li> Social preferences, interests and activities.</li>
      </ul>
      <p> We may collect the following information when you take part in promotions, competitions, surveys or
        questionnaires about our services:</p>
      <ul class="term-list">
        <li>Personal data you provide when you connect with us, including by email, mail, and telephone or through
          social media, such as your name, username and contact details. </li>
        <li>Details of emails and other digital communications we send to you that you open, including any links within
          those communications that you click on. </li>
        <li>Your feedback and contributions to customer surveys and questionnaires.
          Other ways we may collect your personal data: </li>
        <li>Your insurance company, their agents, and medical staff may exchange relevant personal data and special
          categories of personal data with us in circumstances where we/they need to act on your behalf or in the
          interest of other customers or in an emergency. </li>
        <li>If you log-in using your social network credentials to connect to our platforms and online services e.g.
          Facebook, Instagram, Twitter, etc. you will agree to share your user details with us. For example, your name,
          email address, date of birth, location and any other information you choose to share with us. </li>
        <li> We may also get information about you from other sources, such as your Service Providers, affiliates and
          other third-parties like credit reference agencies, payment processors, search engines or social media sites.
          We may use this information with other information you provide in order to complete or process your booking.
        </li>
      </ul>
      <h4> WHEN YOU GIVE US INFORMATION ABOUT OTHERS </h4>
       <p>You will have to give us their information as
        well, for example their name, date of birth, passport information, and ID document information. It’s your
        responsibility to ensure that they are aware that you have done so, and also that they accept how we use and
        process their information.
       </p>
      <h4> CHILDREN’S PRIVACY</h4>
      <p> We only collect personally identifiable information from individuals under the age of 18 with parent or
        guardian consent. If you are booking for a minor, we will request proof of such consent. If you are a parent or
        guardian and you are aware that your minor child has provided us with Personal Data, please contact us. If we
        become aware that we have collected Personal Data from children without verification of parental consent, we
        take steps to remove that information from our servers.</p>
      <h4> Information we collect automatically </h4>
      <p> We may also collect information on how the Website is accessed and used. This may include information such as
        your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our
        services that you visit, the time and date of your visit, the time spent on those pages, unique device
        identifiers and other diagnostic data</p>
      <p> We may use and store information about your location if you give us permission to do so. We use this data to
        provide features of our Services, to improve and customize our Services.</p>
      <p> You can enable or disable location services when you use our Website at any time by way of your device
        settings.</p>

      <h4>TRACKING & COOKIES DATA</h4>
      <p> Our Services make use of cookies to save and retrieve information about your visit to our sites. Cookies are
        small files of software which save and retrieve information about your visit to a website or application. They
        reside in your internet browser to help remember your preferences and previous activity. </p>
      <p> Cookies currently used on our site identify you as an anonymized number. We and our partners (e.g., marketing
        partners, affiliates, or analytics providers) use cookies and log files to analyze trends, administer the
        website, track users’ movements around the website, and gather demographic information about our user base. We
        may receive anonymized reports based on the use of these technologies by our partners on an aggregated basis. We
        also use this data to provide the site’s content, ensure the functionality of our information technology
        systems, and to optimize our website. </p>
      <p> You can control and refuse the use of cookies at the individual browser level. Cookies installed can be
        deleted. If you reject cookies, you may still use our website, but your ability to use some features or areas of
        our website may be limited.</p>

      <h4> GOOGLE ANALYTICS</h4>
      <p> Our website uses Google Analytics, a web analysis service of Google, Inc. (“Google Analytics” or “Google”).
        Google Analytics employs cookies that are stored to your computer in order to facilitate an analysis of your use
        of the site. The information generated by these cookies, such as time, place and frequency of your visits to our
        site, including your IP address, is transmitted to Google’s location in the US and stored there.</p>
      <p> Google may also transfer this information to third parties where required to do so by law or where such third
        parties process this data on Google’s behalf. Google states that it will in never associate your IP address with
        other data held by Google. You can prevent cookies from being installed by adjusting the settings on your
        browser software accordingly. You should be aware, however, that by doing so you may not be able to make full
        use of all the functions of our website.</p>
      <p> Google Analytics also offers a deactivation add-on for most current browsers that provides you with more
        control over what data Google can collect on websites you access. The add-on tells the JavaScript (ga.js) used
        by Google Analytics not to transmit any information about website visits to Google Analytics. However, the
        browser deactivation add-on offered by Google Analytics does not prevent information from being transmitted to
        us or to other web analysis services we may engage.</p>
      <p> Google Analytics also uses electronic images known as web beacons (sometimes called single pixel gifs) and are
        used along with cookies to compile aggregated statistics to analyze how our site is used.</p>
      <p>For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page:
        https://policies.google.com/privacy?hl=en.</p>

      <h4> What we do with the information we gather</h4>
      <p> DC Wellness uses the collected data for various purposes:</p>

      <h4 class="text-lowercase"> To provide the products and services you request </h4>
      <p> We need to process your personal data so that we can manage your account or booking, provide you with the
        products and services you want to buy and help you with any orders and refunds you may request.</p>

      <h4> To manage and improve our products, services and day-to-day operations</h4>
      <p> We use personal data to manage and improve our products, websites, mobile apps, and other services.</p>

      <p> We monitor how our services are used to help protect your personal data, detect and prevent fraud, other
        crimes and misuse of services. This helps ensure that you can safely use our services.</p>

      <p> We may use personal data to respond to and manage security operations, accidents or other similar incidents,
        including medical and insurance purposes.</p>

      <p> We may use personal data to carry out market research and internal research and development, and to develop
        and improve our product range, services, IT systems, security and the way we communicate with you.</p>

      <h4> To personalize your experience</h4>
      <p> We want to ensure that marketing communications relating to our products and services, including online
        advertising, are relevant to your interests.</p>

      <p> To do this we may use your personal data to better understand your interests so that we can try to predict
        what other products, services and information you might be most interested in. This enables us to tailor our
        communications to make them more relevant and interesting for you.</p>

      <p> Looking at your browsing behavior and purchases helps us to better understand you as a customer and it allows
        us to provide you with personalized offers and services.</p>

      <p> We may also measure responses to marketing communications relating to products and services we offer, which
        enables us to offer you products and services that meet your needs as a customer.</p>

      <p> If you do not want to receive personalized services from us, you can change your preferences online, over the
        phone or by emailing us at any time. We will update our records as soon as possible.</p>


      <h4 class="text-lowercase"> To make contact with you and interact with you </h4>
      <p> We want to serve you better as a customer so if you contact us, for example by email, mail, telephone or
        social media, we may use the personal data to provide clarification or assistance to you.</p>

      <p> We may invite you to take part in customer surveys, questionnaires and other market research activities
        carried out by DC Wellness and by other organizations on our behalf. </p>

      <p>
        To help us to better understand you as a customer, and to be able to provide you with services and marketing
        communications (including online advertising relevant to your interests), we may combine the personal data we
        collect when you make purchases in-shop with personal data collected from our websites, mobile apps and other
        sources.
      </p>
      <p> We do not sell your personal data to third parties.</p>
      <h4 class="text-lowercase"> Marketing </h4>
      <p> From time to time we may send you relevant offers and news about our products and services in a number of
        ways, including by email. We may also send you information about other companies’ products and services that we
        believe may be of interest to you. For example, based on your booking history, we may send you information about
        other trips we think may interest you. We will only do this if you previously agreed to receive these marketing
        communications.</p>
      <p> When you book or register with us, we will ask you if you would like to receive marketing communications. You
        can change your marketing preferences online, over the phone, using the “unsubscribe” link in our emails,
        replying STOP to the short code in our marketing text messages or by writing or emailing us at any time. Of
        course, the choice is entirely yours, but if you say you do not want to receive marketing information from us
        you will miss out on receiving great offers and promotions that may be of interest to you.</p>
      <p>
        If you choose to discontinue marketing communication, you may still receive service-related communications
        from us, if we have a legitimate reason to do so. For example, confirming bookings you make with us and
        providing important information about the use of our products and/or services.
      </p>
      <h4 class="text-lowercase"> Sharing Personal Data with Suppliers and Partners</h4>
      <p>
        In order to provide products or services you have requested.
      </p>

      <p>
        We also work with carefully selected suppliers that carry out certain functions on our behalf. For example,
        companies that help us with IT services, storing and combining data, marketing, market research, processing
        payments and delivering products and services.
      </p>

      <p> We may need to share personal data to establish, exercise, or defend our legal rights; this includes providing
        personal data to others for the purpose or preventing fraud and reducing credit risk.</p>

      <p> When we share personal data with other organizations, we require them to keep it safe, and they must not use
        your personal data for their own marketing purposes.</p>

      <p> We only share the minimum personal data that enables our suppliers and retail partners to provide their
        services to you and us.</p>

      <h4 class="text-lowercase"> Sharing Personal Data with Regulatory Authorities</h4>

      <p> To disclose and process your personal data for immigration, border control,
        security and anti-terrorism purposes, or any other purposes which they determine appropriate.
      </p>

      <p> Some countries will only permit travel if you provide your advance passenger data. These requirements may
        differ depending on your destination and you are advised to check. Even if not mandatory, we may assist where
        appropriate.</p>

      <p> We may share the minimum personal data necessary with other public authorities if the law says we must, or we
        are legally allowed to do so. </p>

      <h4> Sharing Personal Data within DC Wellness</h4>
      <p> Our privacy notice applies to all of the services offered by DC Wellness but excludes services that have
        separate privacy notices that do not incorporate this Privacy Notice. We may share the minimum personal data
        necessary with members of DC Wellness for example, to provide the products and services you request; to manage
        and improve our products, services, and day-to-day operations; to help to personalize your experience; where
        appropriate, to make contact and interact with you; and if allowed and appropriate, for marketing purposes.</p>
      <p> We may also share personal data with an organization we sell or transfer (or enter into negotiations to sell
        or transfer) any of our businesses or any of our rights or obligations under any agreement we have with you. If
        the transfer or sale occurs, the organization receiving your personal data will use your data in conformity with
        this privacy policy.</p>

      <h4> LEGAL BASIS FOR PROCESSING PERSONAL DATA </h4>
      <p>DC Wellness may process your Personal Data for the following reasons:</p>

      <ul class="term-list">
        <li>
          <p> <strong> Performance of a contract: </strong> We need to use your information to carry out the contract
            that you have with us and your Service Providers. For example, we will use your information to make bookings
            with the relevant third-party Service Providers. </p>
        </li>
        <li>
          <p> <strong> Consent: </strong> By registering for our website or making a booking you give us consent to
            process your personal data. You may also, through your action(s) of providing us your details, consent to us
            sending you marketing and promotional material. If you do give us this consent, we’ll rely on this consent
            when contacting you. You can always withdraw your consent at any time by unsubscribing. </p>
        </li>
        <li>
          <p> <strong> Legitimate interest: </strong> We may use your information for our own legitimate interest, for
            example to personalize your experience. We may use your personal data to better understand your interests so
            that we can try to predict what other products, services and information you might be most interested in.
            This enables us to tailor our communications to make them more relevant and interesting for you. </p>
        </li>
        <li>
          <p> <strong> Business transaction:  </strong> We may use your data in connection with a business transaction
            such as the sale of a part or the whole of our business. </p>
        </li>
        <li>
          <p> <strong> To Comply with a legal obligation: </strong> So that you can travel, it may be mandatory (as
            required by government authorities at the point(s) of departure and/or destination) to disclose and process
            your personal data for immigration, border control, security and anti-terrorism purposes, or any other
            purposes which they determine appropriate. </p>
        </li>
        <li>
          <p> <strong> To protect your vital interests or those of another individual: </strong> We may share your
            information in the case of an emergency. Your insurance company, their agents and medical staff may exchange
            relevant personal data and special categories of personal data with us in circumstances where we/they need
            to act on your behalf or in the interest of other customers or in an emergency.</p>
        </li>
      </ul>
      <h4> RETENTION OF DATA</h4>
      <p> We will retain your personal data for only as long as it is necessary for the uses set out in this Privacy
        Notice and/or to meet legal and regulatory requirements. After this period, we will securely erase personal
        data. If the data is needed after this period for analytical, historical or other legitimate purposes, we will
        take appropriate measures to anonymize this data.
      </p>
      <h4> TRANSFER OF DATA</h4>
      <p> Your information, including Personal Data, may be transferred to, and maintained on, computers located outside
        of your state, province, country or other governmental jurisdiction (including the EU if you are a European
        citizen), where the data protection laws may differ from those of your jurisdiction.</p>
      <p> If you are located outside United States and choose to provide information to us, please note that we transfer
        the data, including Personal Data, to United States and process it there. </p>
      <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement
        to that transfer.</p>
      <p> DC Wellness will take all the steps reasonably necessary to ensure that your data is treated securely and in
        accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or
        a country unless there are adequate controls in place including the security of your data and other personal
        information.
      </p>

      <h4> SECURITY OF DATA</h4>
      <p> Any information that you provide is stored on secure servers and all payment transactions are encrypted. Only
        authorized personnel are permitted to access your information in the course of their work with us. The security
        of your data is important to us but remember that no method of transmission over the Internet or method of
        electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal
        Data, we cannot guarantee its absolute security.
      </p>

      <h4> OUR POLICY ON “DO NOT TRACK” SIGNALS UNDER THE CALIFORNIA ONLINE PROTECTION ACT (CALOPPA)</h4>

      <p> We do not support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.</p>

      <p> You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>

      <h4> YOUR Rights in Relation to your personal information</h4>

      <p> You have a right to ask for a copy of the personal data we hold about you, although you should be able to access this information online through your account or booking.
        You may request details of personal information which we hold about you. Please include any details to help us identify and locate your personal data.  Where we can provide data access, we will do so free of charge except where further copies are requested in which case a small fee will be payable based on administrative costs.</p>

      <p> If you believe that any information we have pertaining to you is incorrect or incomplete, please write to or email us as soon as possible. We will promptly correct any information found to be incorrect.  </p>

      <p> You can also ask for your information to be rectified or erase, to object to the processing of your personal data and, where technically feasible, to ask for the personal data you provided us to be transferred to another organization. </p>

      <p> We will update or erase your data, unless we have to keep it for legitimate business or legal purposes.</p>

      <p> You can also contact us if you have complaint about how we collect, store or use your personal data.  We aim to resolve your complaints but if you are dissatisfied with our response, you may complain to the local data protection authority.</p>


      <p> Please submit your request or complaint in writing to:</p>

      <p> DC Wellness  <a href="mailto:info@mylifewell.com"> info@mylifewell.com</a> </p>


      <p>Please note that we may ask you to verify your identity before we can act on your request or complaint.  We may also ask you for more information to help ensure that you are authorized to make such a request or complaint when you contact us on behalf of someone else. </p>

      <p>If you are a citizen of the European Union, you have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA). </p>

      <p> If you are a California resident, we may not delete your personal information if one of the following exceptions exists: </p>

      <ul class="term-list">
        <li>
          Information is necessary to complete the transaction;
        </li>
        <li>
          Information is necessary to detect security incidents;
        </li>
        <li>
          Information is necessary to protect against deceptive, fraudulent or illegal activity;
        </li>
        <li>
          Information is necessary to identify and repair errors;
        </li>
        <li>
          Information is necessary to promote free speech;
        </li>
        <li>
          Information is necessary for scientific, historical, or statistical research in the public interest;
        </li>
        <li>
          Information is necessary for internal uses of the company if those uses are reasonably expected by consumers;
        </li>
        <li>
          Information is necessary to comply with a legal obligation; or
        </li>

        <li> Information is used internally in a manner that is compatible with the context of the collection.</li>

      </ul>

      <h4> LINKS TO OTHER SITES</h4>
      <p> Our Services may contain hyperlinks to websites operated by parties other than DC Wellness (for example to social media sites such as Facebook, Instagram, or Pinterest). Such hyperlinks are provided for your reference only. Once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy policy. You should exercise caution and look at the privacy statement applicable to the website in question. </p>

    </div>
  </div>
</div>

